window.onscroll = function() {
    scrollFunction();
};
function scrollFunction() {
    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    if (document.body.clientHeight > window.innerHeight) {
        if (scrollTop > 230) {
            document.getElementById("top").style.display = "block";
            document.getElementById("menu-top").classList.add("menu-stop");
            document.getElementById("home").classList.add("body-stop");
        } else {
            document.getElementById("top").style.display = "none";
            document.getElementById("menu-top").classList.remove("menu-stop");
            document.getElementById("home").classList.remove("body-stop");
        }
    }
}
function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}
